import axios from "axios";
import { errorHandler } from "globalResources/util";
import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const HandleShortLink = () => {
  const { id } = useParams();
  const history = useHistory();

  const processShortLink = async () => {
    try {
      const res = await axios.get(`/link`, {
        params: { id },
      });

      window.location.href = res.data.fullUrl;
    } catch (error) {
      const { message, status } = await errorHandler(error);

      if (status === 404) {
        window.alert("Link not found");
        history.push("/");
      }
      if (status === 403) {
        window.alert("You do not have permission to view this link");
        history.push("/");
      }
    }
  };

  useEffect(() => {
    processShortLink();
  }, [id]);

  return <Main>Navigating to your destination...</Main>;
};
export default HandleShortLink;
